import React from 'react';

import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { CREDIT_CARD_FIELDS } from '../constants';
import { CreditCardInput } from '../credit-card-input';

import style from './style.module.css';

export const CreditCardName = () => {
  return (
    <div className={style.container}>
      <CreditCardInput autoComplete={AutoCompleteField.CCName} className={style.name} field={CREDIT_CARD_FIELDS.CARD_NAME} />
    </div>
  );
};
